module.exports = __webpack_public_path__ + "img/9791186256572.6bcd0596.jpg";